import { Theme } from "@mui/material/styles";

export const individualDeliveryFormStyles = (theme: Theme) => ({
  [theme.breakpoints.down("sm")]: {
    "& > .MuiStack-root": {
      minWidth: 0,
      width: "100%",
    },
    "& .MuiFormControl-root": {
      maxWidth: "100% !important",
      minWidth: 0,
      width: "100% !important",
    },
    "& .RaSimpleFormIterator-root, & .RaSimpleFormIterator-form, & .RaSimpleFormIterator-line": {
      maxWidth: "100%",
      minWidth: 0,
      width: "100%",
    },
    "& .RaSimpleFormIterator-action": {
      marginLeft: 0,
    },
  },
});
